module.exports = __webpack_public_path__ + "static/img/pinpai-7.fe213fc4.png";